import { createContext } from "react";

export const AppContext=createContext();

////for yinitial commit